import { SimpleModel } from '@/models/base/SimpleModel';

export class Depot extends SimpleModel {
  constructor(init?: Partial<Depot>) {
    super();
    Object.assign(this, init);
  }
}
